import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p className="content">
            Hi Everyone, I am <span className="purple">Mohamed Saeed </span>
            from <span className="purple"> Menofia, Egypt.</span>
            <br />
            <br />
            Dedicated Front-end Developer and software instructor with over one
            year of hands-on experience in{" "}
            <span className="purple">Next.js/React.js</span>, along with a solid
            foundation in <span className="purple">Computer Science</span>.
            Recently graduated from <span className="purple">ITI</span>, with
            expertise in building responsive web applications, managing
            projects, and overcoming technical challenges. Passionate about
            continuous learning and thriving in dynamic environments, leveraging
            creativity and problem-solving skills to deliver high-quality
            innovative solutions that drive organizational success and foster
            personal development.
            <br />
            <br />I am currently employed as a software developer at{" "}
            <b className="purple">Future of Egypt</b>
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>

          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Reading Tech Blogs
            </li>

            <li className="about-activity">
              <ImPointRight /> Attending Tech Meetups and Conferences
            </li>
            <li className="about-activity">
              <ImPointRight /> Building Side Projects
            </li>
          </ul>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
